<template>
  <div class="shop">
    <div class="shopTitle">商务合作</div>
    <div class="shopEn">business cooperation</div>
    <img src="https://p2.ssl.qhimg.com/t110b9a93012b1b2c5ef6fc971e.png" alt="" class="shopBox">
    <!-- <div class="shopBox"></div> -->
  </div>
</template>

<script setup></script>

<style lang="scss" scoped>
.shop {
  opacity: 1;
  background: #f3f3f3;
  padding: 32px 16px 88px;
  &Title {
    font-family: Source Han Sans;
    font-size: 18px;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: 0px;
    font-variation-settings: 'opsz' auto;
    /* Gray 中性/gray-9 */
    color: #242933;
  }
  &En {
    font-family: Source Han Sans;
    font-size: 12px;
    font-weight: normal;
    line-height: 18px;
    letter-spacing: 0px;
    font-variation-settings: 'opsz' auto;
    /* Gray 中性/gray-7 */
    color: #8a9099;
    margin: 2px 0 16px;
  }
  &Box {
    width: 100%;
  }
//   &Box {
//     border-radius: 16px;
//     opacity: 1;
//     background: rgba(255, 255, 255, 0.8);
//     backdrop-filter: blur(120px);

//   }
}
</style>
